































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import RangeSlider from "@/components/VRangeSliderStyling.vue";
import ColorPicker from '@/commonComponents/colorPicker/colorPicker.vue';
import AdjustedBalloon from '@/commonComponents/adjustedBalloon/adjustedBalloon.vue';

import * as def from '@/definitions'

import { Design } from '@/model/document2/page/surface/design/design';
import { Layer } from '@/model/document2/page/surface/design/layer/layer';
import { ColorConstruct } from '@/utilityModels/colorConstruct';
import { ExTextLayer } from '@/model/document2/page/surface/design/layer/exTextLayer';
import { SimpleTextLayer } from '@/model/document2/page/surface/design/layer/simpleTextLayer';
import { MathHelper } from '@/helper/mathHelper';

import ColorSelector from "@/commonComponents/colorSelector/colorSelector.vue";

// ボタン
import ArrowDown from "../resources/arrowDown.vue";
import ArrowRight from "../resources/arrowRight.vue";
import CheckBoxOn from "../resources/checkBoxOn.vue";

import { ResourceHelper } from "@/helper/resourceHelper"

@Component({
  components: {
      RangeSlider,
      ColorPicker,
      ColorSelector,
      AdjustedBalloon,
      ArrowDown,
      ArrowRight,
      CheckBoxOn
  },
})

// テキスト選択時, テキスト非選択時共通
// テキスト選択状態の場合は選択テキスト、非選択時は全テキストに適用する
export default class MultipleTextShadow extends Vue
{
    @Prop() private design! : Design;

    // TextEditorのfocusLockを解除する
    private unlockTextEditorFocus()
    {
        // メッセージセンター取得
        var messageCenter = this.$store.getters.messageCenter;
        // メッセージセンターに送信
        messageCenter.send("unlock_text_editor_focus", null);
    }

    // すべてのレイヤーの特定のパラメータを取得する。
    // 一致していなければ null を返す
    private getLayerProperty(property : string) : any
    {
        var value : any = null;
        var isBreak : boolean = false;

        var allLayers = this.design.getSelectLayerWithoutGroup();
        for(var i = 0; i < allLayers.length; ++i)
        {
            var layer = allLayers[i];
            if(layer instanceof ExTextLayer)
            {
                var val = layer[property];
                if(val != null)
                {
                    if(value == null) { value = val; }
                    else if(typeof(value) == "number" && typeof(val) == "number" && MathHelper.equals(value, val)) { value = val; }
                    else if(value instanceof ColorConstruct && val instanceof ColorConstruct && value.equals(val)) { value = val; }
                    else if(value === val) { value = val; }
                    else
                    {
                        isBreak = true;
                        break;
                    }
                }
            }
            else if(layer instanceof SimpleTextLayer)
            {
                var targetValue = layer[property];
                if(targetValue != null)
                {
                    if(value == null) { value = targetValue; }
                    else if(typeof(value) == "number" && typeof(targetValue) == "number" && MathHelper.equals(value, targetValue)) value = targetValue;
                    else if(value instanceof ColorConstruct && targetValue instanceof ColorConstruct && value.equals(targetValue)) value = targetValue;
                    else if(value === targetValue) value = targetValue;
                    else 
                    { 
                        isBreak = true; 
                        break;
                    }
                }
            }
            if(isBreak) { break; }
        }

        if(isBreak) { return null; }

        return value;
    }

    // すべてのレイヤーのすべての文字の文法情報の特定のパラメータを取得する。
    // 一致していなければ null を返す
    private getProperty(property : string) : any
    {
        var value : any = null;
        var isBreak : boolean = false;

        var allLayers = this.design.getSelectLayerWithoutGroup();
        for(var i = 0; i < allLayers.length; ++i)
        {
            var layer = allLayers[i];
            if(layer instanceof ExTextLayer)
            {
                var infoArray = layer.textInfoArray;
                for(var j = 0; j < infoArray.length; ++j)
                {
                    var info = infoArray[j];
                    var val = info[property];
                    if(val != null)
                    {
                        if(value == null) { value = val; }
                        else if(typeof(value) == "number" && typeof(val) == "number" && MathHelper.equals(value, val)) { value = val; }
                        else if(value instanceof ColorConstruct && val instanceof ColorConstruct && value.equals(val)) { value = val; }
                        else if(value === val) { value = val; }
                        else
                        {
                            isBreak = true;
                            break;
                        }
                    }

                    if(isBreak) { break; }
                }
            }
            else if(layer instanceof SimpleTextLayer)
            {
                var baseTextInfo = layer.baseTextInfo;
                var targetValue = baseTextInfo[property];
                if(targetValue != null)
                {
                    if(value == null) value = targetValue;
                    else if(typeof(value) == "number" && typeof(targetValue) == "number" && MathHelper.equals(value, targetValue)) value = targetValue;
                    else if(value instanceof ColorConstruct && targetValue instanceof ColorConstruct && value.equals(targetValue)) value = targetValue;
                    else if(value == targetValue) value = targetValue;
                    else
                    {
                        isBreak = true;
                    }
                }
            }
            if(isBreak) { break; }
        }

        if(isBreak) { return null; }

        return value;
    }

    //↓↓↓↓↓開閉のアニメーション↓↓↓↓↓
    //こいつはpropsでもらいたい
    openStatus = {
        opend : true
    };

    multipleTextShadowContentsOpenAnimate = false;
    multipleTextShadowContentsCloseAnimate = false;

    open(){
        if(this.openStatus.opend){
            this.multipleTextShadowContentsCloseAnimate = true;
            setTimeout(()=>{this.multipleTextShadowContentsCloseAnimate = false; this.multipleTextShadowContentsOpenAnimate = false; this.openStatus.opend = false;}, 200);
        }else{
            this.openStatus.opend = true;
            this.multipleTextShadowContentsOpenAnimate = true;
            setTimeout(()=>{this.multipleTextShadowContentsOpenAnimate = false;}, 250);
        }
    };
    //↑↑↑↑↑開閉のアニメーション↑↑↑↑↑

    // 影
    private get isShadow() : boolean
    {
        var value = this.getProperty("isShadow");
        return (value != null && typeof(value) == "boolean") ? value : false;
    }

    private isShadowChange()
    {
        this.changeTextInfo(!this.isShadow, "isShadow", true);
    }

    // 縁取り
    private get isOutline()
    {
        var value = this.getProperty("isOutline");
        return (value != null && typeof(value) == "boolean") ? value : false;
    }

    private isOutlineChange()
    {
        this.changeTextInfo(!this.isOutline, "isOutline", true);
    }

    // スライダー
    private getSliderValue(propertyName)
    {
        var value = this.getProperty(propertyName);
        return (value != null && typeof(value) == "number") ? value : 0;
    }

    // 影の距離
    private get shadowDistance() { return this.getSliderValue("shadowDistance"); }
    private get shadowDistanceDisplay() { return MathHelper.roundByDigits(this.shadowDistance).toFixed(); }
    private get shadowDistanceValue() { return this.shadowDistance; }
    private set shadowDistanceValue(value)
    {
        this.changeTextInfo(value, "shadowDistance", false);
    }
    private onChangeShadowDistance(value)
    {
        this.changeTextInfo(value, "shadowDistance", true);
    }

    // 影の角度
    private get shadowRotate() { return this.getSliderValue("shadowRotate"); }
    private get shadowRotateDisplay() { return MathHelper.roundByDigits(this.shadowRotate).toFixed(); }
    private get shadowRotateValue() { return this.shadowRotate; }
    private set shadowRotateValue(value)
    {
        this.changeTextInfo(value, "shadowRotate", false);
    }
    private onChangeShadowRotate(value)
    {
        this.changeTextInfo(value, "shadowRotate", true);
    }

    // 影のぼかし
    private get shadowBlur() { return this.getSliderValue("shadowBlur"); }
    private get shadowBlurDisplay() { return MathHelper.roundByDigits(this.shadowBlur, 1).toFixed(); }
    private get shadowBlurValue() { return this.shadowBlur; }
    private set shadowBlurValue(value)
    {
        this.changeTextInfo(value, "shadowBlur", false);
    }
    private onChangeShadowBlur(value)
    {
        this.changeTextInfo(value, "shadowBlur", true);
    }

    // 影の強さ
    private get shadowIntensity() { return this.getSliderValue("shadowIntensity"); }
    private get shadowIntensityDisplay() { return MathHelper.roundByDigits(this.shadowIntensity).toFixed(); }
    private get shadowIntensityValue() { return this.shadowIntensity; }
    private set shadowIntensityValue(value)
    {
        this.changeTextInfo(value, "shadowIntensity", false);
    }
    private onChangeShadowIntensity(value)
    {
        this.changeTextInfo(value, "shadowIntensity", true);
    }

    // 縁取りの太さ
    private get outlineThickness() { return this.getSliderValue("outlineThickness"); }
    private get outlineThicknessDisplay() { return MathHelper.roundByDigits(this.outlineThickness, 1).toFixed(); }
    private get outlineThicknessValue() { return this.outlineThickness; }
    private set outlineThicknessValue(value)
    {
        this.changeTextInfo(value, "outlineThickness", false);
    }
    private onChangeOutlineThickness(value)
    {
        this.changeTextInfo(value, "outlineThickness", true);
    }

    // 縁取りの強さ
    private get outlineIntensity() { return this.getSliderValue("outlineIntensity"); }
    private get outlineIntensityDisplay() { return MathHelper.roundByDigits(this.outlineIntensity).toFixed(); }
    private get outlineIntensityValue() { return this.outlineIntensity; }
    private set outlineIntensityValue(value)
    {
        this.changeTextInfo(value, "outlineIntensity", false);
    }
    private onChangeOutlineIntensity(value)
    {
        this.changeTextInfo(value, "outlineIntensity", true);
    }

    // 色

    // 影色
    private get shadowColor()
    {
        var color =  this.getProperty("shadowColor");
        return color != null && color instanceof ColorConstruct ? color : new ColorConstruct();
    }
    private get shadowColorStyle()
    {
        var color =  this.getProperty("shadowColor");
        return color == null ? { "border-color" : "#000000", "border-width" : "1px", "border-style" : "solid" } : { "background-color" : color.hex };
    }

    private isShadowColorPickerVisible = false;
    private showShadowColorPicker()
    {
        this.isShadowColorPickerVisible = true;
    }
    private closeShadowColorPicker()
    {
        this.isShadowColorPickerVisible = false;
    }

    // 縁取り色
    private get outlineColor()
    {
        var color =  this.getProperty("outlineColor");
        return color != null && color instanceof ColorConstruct ? color : new ColorConstruct();
    }

    private get outlineColorStyle()
    {
        var color =  this.getProperty("outlineColor");
        return color == null ? { "border-color" : "#000000", "border-width" : "1px", "border-style" : "solid" } : { "background-color" : color.hex };
    }

    private isOutlineColorPickerVisible = false;
    private showOutlineColorPicker()
    {
        this.isOutlineColorPickerVisible = true;
    }
    private closeOutlineColorPicker()
    {
        this.isOutlineColorPickerVisible = false;
    }

    // 色変更中
    private onChangingColor(color, tag)
    {
        this.changeTextInfo(color, tag, false);
    }

    // 色変更完了
    private onChangedColor(color, tag)
    {
        this.changeTextInfo(color, tag, true);
    }

    private changeTextInfo(value : any, propertyName : string, isFinish : boolean)
    {
        var allLayers = this.design.getSelectLayerWithoutGroup();
        for(var i = 0; i < allLayers.length; ++i)
        {
            var layer = allLayers[i];

            if(layer.layerType == "plainText")
            {
                this.$emit("doCommand", "changePlainTextLayerWholeTextInfo", {
                    layer : layer,
                    propertyName : propertyName,
                    value : value,
                    isFinish : isFinish && i == allLayers.length - 1
                });
            }
            else if(layer.layerType == "simpleText")
            {
                this.$emit("doCommand", "changeSimpleTextLayerTextInfo", {
                    layer : layer,
                    propertyName : propertyName,
                    value : value,
                    isFinish : isFinish && i == allLayers.length - 1
                });
            }
        }
    }

    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }

    private get userConfigTextAColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textAColor
        };
        return style;
    }

    private get userConfigTextBColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textBColor
        };
        return style;
    }

    getResource(file : string){
        return ResourceHelper.getResource(file);
    }
}



